<script setup>
import { useI18n } from 'vue-i18n'
import BaseModal from './BaseModal.vue'

const props = defineProps({
  open: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close'])

const { t } = useI18n()

const close = () => {
  emit('close')
}
</script>

<template>
  <BaseModal
    :open="open"
    max-width="600px"
    @close="close"
  >
    <template #header>
      <h2 class="m-0 text-xl font-semibold text-vault-text-primary">
        {{ t('helpOverlay.title') }}
      </h2>
    </template>

    <div class="help-content">
      <div class="help-section">
        <h3 class="m-0 text-base font-semibold text-vault-text-primary">
          {{ t('helpOverlay.sections.currency.title') }}
        </h3>
        <p class="m-0 text-sm text-vault-text-secondary leading-relaxed">
          {{ t('helpOverlay.sections.currency.body') }}
        </p>
      </div>

      <div class="help-section">
        <h3 class="m-0 text-base font-semibold text-vault-text-primary">
          {{ t('helpOverlay.sections.funding.title') }}
        </h3>
        <p class="m-0 text-sm text-vault-text-secondary leading-relaxed">
          {{ t('helpOverlay.sections.funding.body') }}
        </p>
      </div>

      <div class="help-section">
        <h3 class="m-0 text-base font-semibold text-vault-text-primary">
          {{ t('helpOverlay.sections.sharing.title') }}
        </h3>
        <p class="m-0 text-sm text-vault-text-secondary leading-relaxed">
          {{ t('helpOverlay.sections.sharing.body') }}
        </p>
      </div>
    </div>

    <template #footer>
      <button
        class="help-button"
        @click="close"
      >
        {{ t('helpOverlay.close') }}
      </button>
    </template>
  </BaseModal>
</template>

<style scoped>
.help-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.help-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.help-button {
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, var(--vault-blue-400), var(--vault-blue-500));
  color: white;
  padding: 0.5rem 1.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.help-button:hover {
  background: linear-gradient(135deg, var(--vault-blue-500), var(--vault-blue-600));
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
  transform: translateY(-1px);
}

.help-button:active {
  transform: translateY(0);
}
</style>
